import classNames from 'classnames'

import * as styles from './PdfViewerSelectionAreaBox.module.css'

import MoreIcon from '../../../icons/textarea-more.svg'

function PdfViewerSelectionAreaBox({
  className,
  disabled = false,
  resizeRef,
  selectBoxRef,
  onMouseDown,
  onResizeMouseDown,
}) {
  return (
    <div
      className={classNames(styles.PdfViewerSelectionAreaBox, className)}
      data-disabled={disabled}
      ref={selectBoxRef}
      onMouseDown={onMouseDown}
    >
      <div
        className={styles.iconWrapper}
        ref={resizeRef}
        onMouseDown={onResizeMouseDown}
      >
        <MoreIcon className={styles.icon} />
      </div>
    </div>
  )
}

export default PdfViewerSelectionAreaBox
